<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="margin-top:20px;"
      v-if="showEsignature"
    >
      <v-card
        elevation="0"
        style="border: 1px solid rgba(26,26,26,0.2);margin:5px;"
      >
        <v-card-text
          style="background: rgba(0,0,0,0.05);"
        >
          <div
            style="background: white;padding: 5px;border: 1px solid rgba(0,0,0,0.1)"
            v-html="section.text"
          />
        </v-card-text>
        <v-card-text
          v-if="envelope"
        >
          <span>
            <v-icon
              left
              size="16"
            >
              mdi-signature-freehand
            </v-icon>
            <b>Status: </b> {{getSignResponse(envelope.pri_signing_status) || 'Signature Requested'}}
          </span>
        </v-card-text>
        <v-card-text
          v-else
        >
          <span>
            <v-icon
              left
              size="16"
            >
              mdi-signature
            </v-icon>
            This signature block would be signed by the primary contact.
          </span>
        </v-card-text>
      </v-card>
    </div>
  </v-expand-transition>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormESignature',
  props: ['userFormId', 'section'],
  data () {
    return {
      loading: false,
      envelope: null
    }
  },
  created () {
    this.getCurrentSignature()
  },
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    },
    getCurrentSignature () {
      this.loading = true
      api.userform.userForm.getEsigns(this.userFormId)
        .then(results => {
          let validEsigns = results.filter(esign => esign.void == false)
          if (validEsigns.length > 0) {
            this.envelope = validEsigns.at(-1)
          } else {
            this.envelope == null
          }
          this.loading = false
        })
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showEsignature(){
      if (!this.checkPermission('userform', this.PERMISSIONS.CAN_EDIT) && this.checkPermission('userform', this.PERMISSIONS.CAN_CONTACT_EDIT))
        return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
      return true
    },
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>
